module.exports = __webpack_public_path__ + "static/img/liandanlu.3ec2c5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/liandanlu.png
// module id = nE0p
// module chunks = 3